import { FinanceOptionRecord, financeOptionFromJSON } from "common/records/FinanceOption";
import { Map, Record } from "immutable";
import { Nullable } from "common/records";
import { RootState, RootActions } from "common/reducers";
import { receive, reset } from "common/reducers/Utils";
import {
  FinanceOptionActions,
  RECEIVE_FINANCE_OPTION,
  RECEIVE_FINANCE_OPTIONS,
  REMOVE_FINANCE_OPTION,
  RESET_FINANCE_OPTION,
  SET_FINANCE_OPTIONS_LOADED_FOR_ORG_ID,
} from "common/reducers/financeOption.actions";

export const FinanceOptionStateRecord = Record({
  byId: Map<number, FinanceOptionRecord>(),
  lastSavedById: Map<number, FinanceOptionRecord>(),
  loadedForOrgId: null as Nullable<number>,
});

export const initialState = FinanceOptionStateRecord();
export type FinanceOptionState = typeof initialState;

const rootKey = "financeOptions";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([rootKey])) {
    state = state.setIn([rootKey], initialState);
  }
  switch (action.type) {
    case RECEIVE_FINANCE_OPTION:
      const financeOption = financeOptionFromJSON({ ...action.payload });

      return receive(state, rootKey, financeOption) as RootState;

    case RECEIVE_FINANCE_OPTIONS:
      action.payload.financeOptions.forEach((financeOption) => {
        state = reducer(state, FinanceOptionActions.receiveFinanceOption(financeOption));
      });

      return state;

    case REMOVE_FINANCE_OPTION:
      return state.removeIn([rootKey, "byId", action.payload]);

    case SET_FINANCE_OPTIONS_LOADED_FOR_ORG_ID:
      return state.setIn([rootKey, "loadedForOrgId"], action.payload) as RootState;

    case RESET_FINANCE_OPTION:
      return reset(state, rootKey, action.payload) as RootState;
    default:
      return state;
  }
};
